export { default as TabbedHeader } from './tabbed-header';
